import React from 'react';
import classnames from 'classnames';
import moment from 'moment';
import styles from '../mailInfo.module.scss';
import { reminderOpts } from '@web-schedule/components/CreateBox/util';
import { useAppSelector } from '@web-common/state/createStore';
import { getIn18Text } from 'api';
const taskMailDate = (taskMailState) => {
    const { endDate, endTime, nonEndTime } = taskMailState;
    const endYYYY = moment(endDate).format(getIn18Text('YYYYNIAN@'));
    const endMMMdo = moment(endDate).format(getIn18Text('MMYUEDD'));
    const endClock = moment(endTime).format('LT');
    let res = `${endYYYY}${endMMMdo}`;
    if (!nonEndTime) {
        res += ` ${endClock}`;
    }
    return res;
};
const TaskMailDesc = () => {
    var _a;
    const taskMailState = useAppSelector(state => state.mailReducer.currentMail.taskMail);
    if (!taskMailState)
        return null;
    const { expireRemindEveryday, enmuReminders, nonEndDate, nonEndTime } = taskMailState;
    const date = taskMailDate(taskMailState);
    const reminderDesc = (_a = reminderOpts(nonEndTime).find(i => i.value === enmuReminders)) === null || _a === void 0 ? void 0 : _a.label;
    const expireRemind = expireRemindEveryday ? getIn18Text('YUQIHOUMEITIAN11') : null;
    return nonEndDate ? (React.createElement("span", null, getIn18Text('CIRENWUWUJIE'))) : (React.createElement(React.Fragment, null,
        React.createElement("span", { className: classnames(styles.descItem) },
            React.createElement("img", { className: classnames(styles.conferenceDescIcon), src: require('@/images/icons/calendarDetail/clock.png'), alt: "" }),
            date,
            getIn18Text('JIEZHI')),
        React.createElement("span", { className: classnames(styles.descItem) },
            reminderDesc && React.createElement("img", { className: classnames(styles.conferenceDescIcon), src: require('@/images/icons/calendarDetail/bell.png'), alt: "" }),
            reminderDesc,
            reminderDesc && expireRemind && ' | ',
            expireRemind)));
};
export default TaskMailDesc;
